import { useEffect, useState } from 'react';
import { Flame, CalendarCheck2, Trophy } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

const Metric = ({ icon: Icon, value, label, tone, testId }) => (
  <div className={`rounded-2xl border p-4 md:p-5 text-center ${tone}`} data-testid={testId}>
    <Icon className="w-4 h-4 mx-auto mb-1.5 opacity-70" />
    <div className="text-2xl md:text-3xl font-extrabold tabular-nums min-h-[2.25rem]">{value}</div>
    <div className="text-[11px] font-semibold opacity-80 mt-0.5">{label}</div>
  </div>
);

const readCache = (key) => {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
};

const HonorBoardCard = () => {
  const { user } = useAuth();
  const CACHE_KEY = `my-rank-cache-${user?.reader_number || ''}`;
  const [me, setMe] = useState(() => readCache(CACHE_KEY));

  useEffect(() => {
    api.get('/streak/my-rank').then((r) => {
      setMe(r.data);
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(r.data)); } catch { /* ignore */ }
    }).catch(() => {});
  }, [CACHE_KEY]);

  const peers = me?.gender === 'female' ? 'قارئة' : 'قارئ';
  const dash = <span className="inline-block w-10 h-6 rounded-md bg-current opacity-10 animate-pulse align-middle" />;

  return (
    <div className="ds-card" data-testid="my-castle-card">
      <div className="grid grid-cols-3 gap-3">
        <div className="rounded-2xl border border-[#C19A6B]/25 bg-gradient-to-br from-[#C19A6B]/15 to-transparent p-4 md:p-5 text-center text-accent" data-testid="my-castle-rank">
          <Trophy className="w-4 h-4 mx-auto mb-1.5 text-[#C19A6B]" />
          <div className="text-2xl md:text-3xl font-extrabold tabular-nums min-h-[2.25rem]">{me ? (me.rank ? `#${me.rank}` : '—') : dash}</div>
          <div className="text-[11px] font-semibold text-muted-foreground mt-0.5">{me ? `من ${me.total} ${peers}` : '\u00A0'}</div>
        </div>
        <Metric icon={Flame} value={me ? me.current_streak : dash} label="أيام متتالية" tone="border-rose-200/70 bg-rose-50/60 text-rose-800" testId="my-castle-streak" />
        <Metric icon={CalendarCheck2} value={me ? me.total_active_days : dash} label="يوم نشاط" tone="border-[#3A5F0B]/20 bg-[#3A5F0B]/5 text-[#3A5F0B]" testId="my-castle-active-days" />
      </div>
    </div>
  );
};

export default HonorBoardCard;
